import apiPdca from '../../../../helpers/apiPdca'
import { loading, loaded, modalAlertaInfo, modalAlertaClean } from '../../../../layout/redux/layoutActions'


export const clearRejeitarPlano = () => ({
  type: 'CLEAR_REJEITAR_PLANO'
})

export const fetchMotivosRejeicao = ciclo => {
  return async (dispatch, getState) => {
    const { sistema } = getState().layoutState
    const nlsPopup = require(`../../../../layout/nlsPopup/${sistema.idioma}.json`)
    

    dispatch({ type: 'FETCH_MOTIVOS_REJEICAO_REQUEST' })
    dispatch(loading())

    try {
      const { data } = await apiPdca.post('/pdca/listamotivosrejeitarcicloplano', {
        ciclo
      })

      if (!data?.ok) {
        throw new Error('Erro ao carregar motivos de rejeição.')
      }

      const motivos = (data?.motivos || []).map(item => ({
        label: item.titulo,
        value: item.codigo,
        id: item.id,
        codigo: item.codigo,
        titulo: item.titulo
      }))

      dispatch({
        type: 'FETCH_MOTIVOS_REJEICAO_SUCCESS',
        payload: motivos
      })
    } catch (error) {
      dispatch({
        type: 'FETCH_MOTIVOS_REJEICAO_FAILURE',
        payload: error
      })

      dispatch(
        modalAlertaInfo(nlsPopup[7], '', () => {
          dispatch(modalAlertaClean())
        })
      )
    } finally {
      dispatch(loaded())
    }
  }
}

const obterPayloadPorCiclo = ({ ciclo, planoId, motivoCodigo, comentario }) => {
  const payloadBase = {
    motivoRejeicaoCodigo: motivoCodigo,
    motivoRejeicaoComentario: comentario || ''
  }

  if (ciclo === 'plan') {
    return {
      endpoint: '/pdca/rejeitarplanoplan',
      payload: {
        planoId,
        ...payloadBase
      }
    }
  }

  if (ciclo === 'do') {
    return {
      endpoint: '/pdca/rejeitaracao',
      payload: {
        pdcaPlanoId: planoId,
        ...payloadBase
      }
    }
  }

  if (ciclo === 'check') {
    return {
      endpoint: '/pdca/rejeitarcheck',
      payload: {
        pdcaPlanoId: planoId,
        ...payloadBase
      }
    }
  }

  throw new Error('Ciclo inválido para rejeição.')
}

export const rejeitarPlano = ({ ciclo, planoId, motivoCodigo, comentario }) => {
  return async (dispatch, getState) => {
    const { sistema } = getState().layoutState
    const nlsPopup = require(`../../../../layout/nlsPopup/${sistema.idioma}.json`)

    dispatch({ type: 'REJEITAR_PLANO_REQUEST' })
    dispatch(loading())

    try {
      const { endpoint, payload } = obterPayloadPorCiclo({
        ciclo,
        planoId,
        motivoCodigo,
        comentario
      })

      const { data } = await apiPdca.post(endpoint, payload)

      const retornoComSucesso = data?.sucesso === true || data?.ok === true

      if (!retornoComSucesso) {
        throw new Error('Erro ao rejeitar plano.')
      }

      dispatch({ type: 'REJEITAR_PLANO_SUCCESS' })
      return true
    } catch (error) {
      dispatch({
        type: 'REJEITAR_PLANO_FAILURE',
        payload: error
      })

      dispatch(
        modalAlertaInfo(nlsPopup[7], '', () => {
          dispatch(modalAlertaClean())
        })
      )

      return false
    } finally {
      dispatch(loaded())
    }
  }
}